const EVALUATION_STATUSES = {
    NOT_STARTED: 'NOT STARTED',
    PENDING: 'PENDING',
    FINISHED: 'FINISHED',
    NOT_CERTIFIED: 'NOT_CERTIFIED',
    CERTIFIED: 'CERTIFIED',
    EXPIRED: 'EXPIRED',
    REMOVED: 'REMOVED'
};

export default EVALUATION_STATUSES;



// WEBPACK FOOTER //
// ./src/app/constants/evaluationStatuses.constant.js